"use client";

import React from "react";
import Navigation from "./Navigation";
import type { NavigationProps } from "./Navigation";

export default function NavigationClient(props: NavigationProps) {
  return <Navigation {...props} />;
}
